import { Dispatch } from 'redux';
import { EmploymentState } from '../../pages/arc/features/employment/employment-model';
import { setExternalLinkState } from '../ducks/app-context';
import { ExternalLinkState } from '../models/app-context-model';
import { AuthenticatedState } from '../models/authenticated-model';
import { DemographicAppKeys } from '../models/demographics-model';
import { RegisterLinkClick } from './analytics-helper';
import { replaceAll } from './string-helpers';

const cicConsentLink = 'consentformlink.com';
export function addQueryParams(baseUrl: string, queryParams: Object) {
	const populatedParams = Object.keys(queryParams).filter(key => !!queryParams[key]);

	return populatedParams.reduce((str, key, index) => {
		return `${str}${index > 0 ? '&' : '?'}${key}=${queryParams[key]}`;
	}, baseUrl);
}

export function handleExternalLinkClick(e: React.MouseEvent<HTMLElement>,
	dispatch: Dispatch<any>,
	history: any,
	location: any,
	authenticatedState: AuthenticatedState,
	employmentState: EmploymentState,
	app: DemographicAppKeys,
	employeeSelect: string,
	externalhandler?: () => void,
	forceReloadTcsm?: boolean,
) {
	const targetLink = (e.target as HTMLElement)?.closest('a') as HTMLAnchorElement;
	const isExternal = !targetLink?.href?.includes(`${window.location.protocol}//${window.location.host}`);
	const linkContent = targetLink?.text;
	const isTcsmLink = targetLink?.href?.includes(`${window.location.host}/services`);
	const compReviewFile = targetLink?.href?.includes('compReviewFile');
	if (targetLink?.href?.toLowerCase()?.includes(cicConsentLink) && externalhandler) {
		e.preventDefault();
		externalhandler();
		return;
	}
	if (!targetLink || (!isExternal && !isTcsmLink && !compReviewFile)) return;
	if (forceReloadTcsm && isTcsmLink) return;
	e.preventDefault();

	if (isExternal) {
		const externalLinkState: ExternalLinkState = {
			renderModal: true,
			linkUrl: targetLink.href,
			linkInnerHtml: targetLink.innerHTML,
		};

		if (targetLink.href?.includes('{personGuid}')) {
			if (app === DemographicAppKeys.myCPG) {
				externalLinkState.linkUrl = replaceAll(externalLinkState.linkUrl, '{personGuid}', authenticatedState?.clientGuid);
			}
			if (app === DemographicAppKeys.arc) {
				if (employmentState?.currentEmployee) {
					externalLinkState.linkUrl = replaceAll(externalLinkState.linkUrl, '{personGuid}', employmentState.currentEmployee?.guid);
				} else {
					// admin context and no employee select, redirect to select employee
					history.push({
						pathname: employeeSelect,
						state: {
							actionLink: location.pathname,
							externalLinkAction: targetLink.href,
						},
					});
					return;
				}
			}
		}

		RegisterLinkClick(linkContent, externalLinkState.linkUrl);
		dispatch(setExternalLinkState(externalLinkState));
	} else if (isTcsmLink) {
		RegisterLinkClick(linkContent, targetLink.pathname);
		history.push(targetLink.pathname);
	} else if (compReviewFile) {
		history.push(targetLink.pathname);
		externalhandler();
	}
}

export function handleExternalDestinationClick(
	destinationUrl: string,
	dispatch: Dispatch<any>,
	history: any,
	location: any,
	authenticatedState: AuthenticatedState,
	employmentState: EmploymentState,
	app: DemographicAppKeys,
	employeeSelect: string,
	externalhandler?: () => void,
) {
	if (!destinationUrl) return;

	const isExternal = !destinationUrl?.includes(window.location.host);
	const isTcsmLink = destinationUrl?.includes(`${window.location.host}/services`);
	const compReviewFile = destinationUrl.includes('compReviewFile');

	if (!isExternal && !isTcsmLink && !compReviewFile) return;

	if (isExternal) {
		const externalLinkState: ExternalLinkState = {
			renderModal: true,
			linkUrl: destinationUrl,
			linkInnerHtml: '',
		};

		if (destinationUrl?.includes('{personGuid}')) {
			if (app === DemographicAppKeys.myCPG) {
				externalLinkState.linkUrl = replaceAll(externalLinkState.linkUrl, '{personGuid}', authenticatedState?.clientGuid);
			}
			if (app === DemographicAppKeys.arc) {
				if (employmentState?.currentEmployee) {
					externalLinkState.linkUrl = replaceAll(externalLinkState.linkUrl, '{personGuid}', employmentState.currentEmployee?.guid);
				} else {
					// admin context and no employee select, redirect to select employee
					history.push({
						pathname: employeeSelect,
						state: {
							actionLink: location.pathname,
							externalLinkAction: destinationUrl,
						},
					});
					return;
				}
			}
		}

		dispatch(setExternalLinkState(externalLinkState));
	} else if (isTcsmLink) {
		history.push(destinationUrl);
	} else if (compReviewFile) {
		externalhandler();
	}
}